import {
    useEffect,
    useState,
} from 'react';

import {Autocomplete,} from '@mantine/core';
import {FieldProps} from 'formik';
import {useProducts} from "../hooks/useProducts.ts";
import {
    Product,
    ProductStatus
} from "../types.ts";


export const ProductsAutocomplete = ({
                                             field: {
                                                 name,
                                                 value: fieldValue,
                                             },
                                             form: {setFieldValue},
                                             ...rest
                                         }: FieldProps) => {

    const LABEL_PROPERTY = 'name'
    const VALUE_PROPERTY = 'id'

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(false);

    const {
        items: records,
    } = useProducts({status: ProductStatus.Active});


    useEffect(() => {
        if (records.length === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [records.length]);

    useEffect(() => {
        const found = records.find((record: Product) => record[VALUE_PROPERTY] === fieldValue);
        if (typeof found !== 'undefined') {
            setValue(found[LABEL_PROPERTY]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally narrow deps: this effect calls setValue, and the full dependency set changes identity every render, which would loop
    }, [records.length]);

    const handleChange = (value: string) => {
        const found = records.find((record: Product) => record[LABEL_PROPERTY] === value);
        if (typeof found !== 'undefined') {
            setFieldValue(name, found[VALUE_PROPERTY]);
        }
        setValue(value);
    };

    const data = records.map((record: Product) => {
        return {
            label: record[LABEL_PROPERTY],
            value: record[VALUE_PROPERTY],
        };
    });


    return (
        <Autocomplete
            name={name}
            value={value}
            onChange={handleChange}
            data={data}
            disabled={disabled}
            placeholder='Select Component'
            {...rest}
        />
    );
};
